// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2fWTI","formContainer":"styles_formContainer__25rl9","buttons":"styles_buttons__LmpHV","support":"styles_support__37jgx"};